import { toLinkInBioSocialUrl } from './socialLinks';
import type { LinkInBio, LinkInBioAlign, LinkInBioLook, LinkInBioSocial } from './types';

const HEX_COLOR = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;
const DEFAULT_BRAND_COLOR = '#000000';

export type LinkInBioProfileView = {
  title: string;
  bio: string | null;
  avatarUrl: string | null;
  look: LinkInBioLook;
  align: LinkInBioAlign;
  brandColor: string;
  socials: LinkInBioSocial[];
};

type ProfileInput = Pick<LinkInBio, 'title' | 'bio' | 'avatar' | 'look' | 'align' | 'socials'>;

type SellerInput = {
  displayName?: string | null;
  name?: string | null;
  logo?: { url?: string | null } | null;
  brandColor?: string | null;
};

export function toLinkInBioBrandColor(color: string | null | undefined): string {
  const trimmed = color?.trim() ?? '';
  return HEX_COLOR.test(trimmed) ? trimmed : DEFAULT_BRAND_COLOR;
}

export function toLinkInBioProfileView(
  profile: ProfileInput,
  seller: SellerInput,
): LinkInBioProfileView {
  return {
    title: profile.title?.trim() || seller.displayName?.trim() || seller.name || '',
    bio: profile.bio?.trim() || null,
    avatarUrl: profile.avatar?.url || seller.logo?.url || null,
    look: profile.look ?? 'theme',
    align: profile.align ?? 'center',
    brandColor: toLinkInBioBrandColor(seller.brandColor),
    socials: (profile.socials ?? []).flatMap(social => {
      const url = toLinkInBioSocialUrl(social.platform, social.url);
      return url ? [{ platform: social.platform, url }] : [];
    }),
  };
}
